// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cd5Iw{display:flex;justify-content:center;padding-block:24px}`, "",{"version":3,"sources":["webpack://./src/components/LoadingSpinner/LoadingSpinner.module.scss"],"names":[],"mappings":"AACA,OACI,YAAA,CACA,sBAAA,CACA,kBAAA","sourcesContent":["@import \"/home/runner/work/commerce-studio/commerce-studio/apps/commerce-studio/src/styles/shared/utils.scss\";\n.loadingSpinner {\n    display: flex;\n    justify-content: center;\n    padding-block: 24px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loadingSpinner": `cd5Iw`
};
export default ___CSS_LOADER_EXPORT___;
